//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { meta } from '~/utils/meta'

export default {
  data () {
    return {
      article: null
    }
  },
  fetchKey (getCounter) {
    return `_blog-article:${this.$route.path}:${getCounter('article-page')}`
  },
  async fetch () {
    let articleRes = null
    try {
      articleRes = await this.$sb.get(`cdn/stories${this.$url.blogArticle(this.$route.params.article)}`)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn(e, 'article slug: ' + this.$route.params.article)

      return this.$nuxt.error({ statusCode: 404, message: 'Article not found' })
    }

    const story = articleRes.data.story
    this.article = {
      id: story.uuid,
      title: story.content.title,
      author: story.content.author,
      intro: story.content.intro,
      meta_description: story.content.meta_description,
      meta_image_text: story.content.meta_image_text,
      long_text: story.content.long_text,
      slug: story.slug,
      date: new Date(story.first_published_at || story.created_at),
      image: this.$sb.parseImage(story.content.image),
      author_image: this.$sb.parseImage(story.content.author_image)
    }
  },
  head () {
    return meta({
      title: this.article?.title,
      description: this.article?.meta_description,
      ogImage: this.article?.image?.filename ? this.$img(this.article?.image?.filename, { width: 1200 }) : null,
      ogImageText: this.article?.meta_image_text?.text,
      ogType: 'article'
    })
  }
}
